'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Services = function Services(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M21.2216 18.3504L16.1771 13.3034H15.2349L12.8173 15.7222V16.6649L17.8618 21.7119C18.233 22.0833 18.8326 22.0833 19.2038 21.7119L21.2216 19.6931C21.5928 19.3313 21.5928 18.7218 21.2216 18.3504Z"
  }), React__default["default"].createElement("path", {
    d: "M17.1004 10.7513L18.4424 9.40864L20.4602 11.4274C21.5738 10.3133 21.5738 8.50399 20.4602 7.38983L17.0909 4.01881L15.7488 5.3615V2.67611L15.0826 2L11.7133 5.37103L12.389 6.04714H15.0826L13.7406 7.38983L14.7495 8.39924L11.9988 11.1513L8.06794 7.21843V5.86621L5.19355 2.99036L2.5 5.68528L5.38391 8.57065H6.72592L10.6568 12.5035L9.84778 13.3129H7.82999L2.78554 18.36C2.41434 18.7313 2.41434 19.3313 2.78554 19.7027L4.80332 21.7215C5.17451 22.0928 5.77414 22.0928 6.14533 21.7215L11.1898 16.6744V14.6556L16.0915 9.75146L17.1004 10.7513Z"
  }));
};

var Services$1 = iconStyles()(Services);

module.exports = Services$1;
